/* unplugin-vue-components disabled */import { render } from "./Upload.vue.js?vue&type=template&id=1479bd6d!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Upload.vue?vue&type=template&id=1479bd6d"
const script = {}

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__